import { toast } from "react-toastify";
import { addCartDataRes } from "../../Api/Cart/CartAPIService";
import { NetworkError } from "../../Api/Error.type";
import { AxiosError } from "axios";

export const SuccessMsgToaster = (data: addCartDataRes | string) => {
  const message = typeof data === "string" ? data : data.data!;
  toast.success(message, {
    position: "top-right",
    autoClose: 2500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const ErrorMsgToaster = (err: string | NetworkError | AxiosError | any) => {
  // Handle cases safely and generically
  const message =
    typeof err === "string"
      ? err
      : err?.response?.data?.error || // Axios backend error
        err?.error || // custom error type
        err?.message || // JS error
        "Something went wrong!";

  toast.error(message, {
    position: "top-right",
    autoClose: 2500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};
